import { ajaxSend } from '../../../../api/api';
export const base = '/v1/companies';
export function createCompany(company) {
    return ajaxSend({
        path: base,
        method: 'POST',
        data: company,
    });
}
export function getPresigned(payload) {
    return ajaxSend({
        path: '/v1/uploads/presigned_url/user_avatar',
        method: 'POST',
        data: {
            pretty_name: payload.file.name,
            content_type: payload.file.type,
        },
    });
}
export function uploadAvatar(payload) {
    return ajaxSend({
        method: 'PUT',
        headers: {
            authorization: null,
            contentType: payload.file.type,
        },
        data: payload.file,
        path: payload.presigned.upload_url,
    });
}
export function readRelatedUsers(companyId) {
    return ajaxSend({
        path: `${base}/${companyId}/users`,
    });
}
export function readCompany(companyId) {
    return ajaxSend({
        path: `${base}/${companyId}`,
    });
}
export function updateCompany(payload) {
    return ajaxSend({
        method: 'PATCH',
        path: `${base}/${payload.companyId}`,
        data: payload.patch,
    });
}
